module.exports = __webpack_public_path__ + "static/media/cube.aef64820.svg";